import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";
import reviewReport from "../review/review_report";

const assessment = new RestResource({server: ASSESSMENT_SERVER, resource: 'assessment'});

assessment.workflowAudit = function (params) {
    let url = `${ASSESSMENT_SERVER}/${assessment.resource}/workflow/audit`;
    return athubAxios.postByMultipartForm(url, params);
};

export default assessment;